import { Img } from "@chakra-ui/image";
import { Box, Container, Flex, Grid, Text } from "@chakra-ui/layout";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ComparePriceTable from "../component/ComparePriceTable";
import Footer from "../component/landingpage/footer/Footer";
import TopNav from "../component/landingpage/header/TopNav";

let features = [
  {
    title: "Expert-led courses",
    detail: "Keep up with in-depth courses from industry leaders.",
  },
  {
    title: "Guided Learning",
    detail:
      "Validate skill levels and measure progress towards learning objectives.",
  },
  {
    title: "Hands-on Learning",
    detail:
      "Apply knowledge with interactive courses and practice assessments.",
  },
];

const Compare = () => {
  const [services, setServices] = useState({});

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_API}packages`)
      .then((res) => {
        setServices(res.data.data);
      })
      .catch((err) => console.log({ err }));
  }, []);

  return (
    <>
      <TopNav />
      <Flex
        sx={{
          height: "240px",
          backgroundImage: "url('/images/slide3.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        align="center"
        justify="center"
      >
        <Text
          sx={{
            fontWeight: 700,
            fontSize: "50px",
            textAlign: "center",
            color: "#FFFFFF",
          }}
        >
          Learning and development
        </Text>
      </Flex>

      <Container maxW="container.lg" mt="10">
        <Box mx="12">
          <Text
            sx={{ textAlign: "center", fontSize: "24px", color: "#213C5C" }}
          >
            Your personal learning management system
          </Text>

          <Grid
            templateColumns={["1fr", null, "repeat(2, 1fr)", "repeat(3, 1fr)"]}
            gap="50px"
            sx={{ alignItems: "center" }}
            mt="12"
          >
            {features.map((feature) => (
              <Box key={feature.title}>
                <Flex align="center">
                  <Img src="/icons/grid.svg" width="48px" height="48px" />
                  <Text>{feature.title}</Text>
                </Flex>
                <Text mt="10">{feature.detail}</Text>
              </Box>
            ))}
          </Grid>
        </Box>
      </Container>

      <Container maxW="container.lg" my="16" sx={{ overflow: "auto" }}>
        <ComparePriceTable services={services} />
      </Container>

      <Footer />
    </>
  );
};

export default Compare;
